import { apiGet } from '../../../adapters/api-client/api';
import { BookingState } from './booking';

/**
 * Mirrors `CalendarEntry` in
 * backend/.../booking/application/calendar.service.ts.
 *
 * The endpoint is role-filtered server-side: a teacher gets their own sessions,
 * a parent gets their children's. There is no teacherId/parentId parameter, and
 * the caller cannot ask for anyone else's calendar.
 */
export interface CalendarEntry {
  bookingId: string;
  enrollmentId: string;
  milestoneSequence: number;
  state: BookingState;
  /** ISO instant. */
  scheduledStart: string;
  scheduledEnd?: string;
  courseId: string;
  courseTitle?: string;
  childFirstName?: string;
  teacherId: string;
  parentId: string;
}

/**
 * Confirmed and rescheduled bookings in `[from, to]`, ordered by start.
 *
 * Both bounds are optional to the API; this screen always sends them, because
 * an unbounded calendar reads every booking the requester has ever had.
 */
export function getMyCalendar(from?: string, to?: string): Promise<{ calendar: CalendarEntry[] }> {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const query = params.toString();
  return apiGet(`/api/v1/me/calendar${query ? `?${query}` : ''}`);
}
